export default "__VITE_ASSET__5385e872__"